const allScreenLabel = {
  CHRONIC_PREVALENCE: 'chronic_prevalence',
  DISEASE_PRELAVENCE: 'disease_prevalence',
  GLP_DRUGS: 'glp_drugs',
  NON_SPECIALITY_DRUGS: 'non_speciality_drugs',
  PHARMACY_UTILIZATION: 'pharmacy_utilization',
  RX_UTILIZATION: 'rx_utilization',
  SPECIALITY_DRUGS: 'speciality_drugs',
  TOP_PROCEDURES: 'top_providers',
  UTILIZATION_PROCEDURE: 'utilization_procedure',
  CARE_QUALITY: 'care_quality',
  PATIENT_UTILIZATION: 'patient_utilization',
  REPORT_PLAN_50_50: 'report_plan_50_50',
  SUMMARY: 'summary',
  PLAN_PERFORMANCE: 'plan_performance',
  CLAIMS_METRICS: 'claims_metrics',
  ENROLLMENT_METRICS: 'enrollment_metrics',
  NETWORK_USAGE: 'network_usage',
  HIGH_COST_CLAIMS: 'high_cost_claims',
};

export default allScreenLabel;
